// @flow
export const LOAD_COOKIES = 'hive/cookies/LOAD_COOKIES';
export const COOKIES_LOADED = 'hive/cookies/COOKIES_LOADED';
export const SET_COOKIE = 'hive/cookies/SET_COOKIE';
export const COOKIE_SET = 'hive/cookies/COOKIE_SET';



// WEBPACK FOOTER //
// ./src/core/state/cookies/constants.js